import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { flexibleSubscriptionsApi } from '@flexible-reports/store/api/subscriptions/subscriptions';
import { flexibleReportsApi } from '@flexible-reports/store/api/reports/reports';
import { accountsApi } from '@flexible-reports/store/api/accounts/accounts';
import { campaignsApi } from '@flexible-reports/store/api/campaigns/campaigns';
import { templatesApi } from '@flexible-reports/store/api/templates/templates';
import { amcTemplatesApi } from '@flexible-reports/store/api/templates/amc-templates';
import { metadataApi } from '@flexible-reports/store/api/metadata/metadata';
import { reportCostEstimationApi } from '@flexible-reports/store/api/report-cost-estimation/report-cost-estimation';
import { userPreferencesApi } from '@flexible-reports/store/api/user-preferences/user-preferences';
import { metricsMiddleware } from '@flexible-reports/store/slices/metrics/metrics-middleware';
import snackbarReducer from '@urc-ui/store/slices/snackbar/snackbarSlice';
import FlexibleReportsLandingPageReducer from '@flexible-reports/store/slices/landing/flexible-reports-landing-page-slice';
import FlexibleReportFormReducer from '@flexible-reports/store/slices/report-form/flexible-report-form-slice';
import reportsDataTableReducer from '@urc-ui/store/slices/view-subscription/reportsDataTableSlice';
import OnlineReportBuilderReduce from '@flexible-reports/store/slices/online-report-slices/online-report-slice';
import ReportHistoryReducer from '@flexible-reports/store/slices/report-history/report-history-slice';
import TemplateWorkflowReducer from '@flexible-reports/store/slices/template-workflow-slice';
import { analysisApi } from './api/analysis/analysis';
import adsAgentChatReducer from '@flexible-reports/store/slices/ads-agent-chat/ads-agent-chat-slice';

export const rootReducer = combineReducers({
  [flexibleSubscriptionsApi.reducerPath]: flexibleSubscriptionsApi.reducer,
  [flexibleReportsApi.reducerPath]: flexibleReportsApi.reducer,
  [accountsApi.reducerPath]: accountsApi.reducer,
  [campaignsApi.reducerPath]: campaignsApi.reducer,
  [templatesApi.reducerPath]: templatesApi.reducer,
  [amcTemplatesApi.reducerPath]: amcTemplatesApi.reducer,
  [metadataApi.reducerPath]: metadataApi.reducer,
  [reportCostEstimationApi.reducerPath]: reportCostEstimationApi.reducer,
  [analysisApi.reducerPath]: analysisApi.reducer,
  [userPreferencesApi.reducerPath]: userPreferencesApi.reducer,
  reportsDataTable: reportsDataTableReducer,
  snackbarMessages: snackbarReducer,
  flexibleReportsLandingPage: FlexibleReportsLandingPageReducer,
  flexibleReportForm: FlexibleReportFormReducer,
  OnlineReportBuilder: OnlineReportBuilderReduce,
  reportHistory: ReportHistoryReducer,
  templateWorkflow: TemplateWorkflowReducer,
  adsAgentChat: adsAgentChatReducer
});

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(flexibleSubscriptionsApi.middleware)
      .concat(flexibleReportsApi.middleware)
      .concat(accountsApi.middleware)
      .concat(campaignsApi.middleware)
      .concat(templatesApi.middleware)
      .concat(amcTemplatesApi.middleware)
      .concat(metadataApi.middleware)
      .concat(reportCostEstimationApi.middleware)
      .concat(analysisApi.middleware)
      .concat(userPreferencesApi.middleware)
      .concat(metricsMiddleware)
});

export default store;
